export default "__VITE_ASSET__6f11d91d__"